var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.clicked}},[_c('i',{staticClass:"fa fa-money"},[_vm._v(" ")]),_vm._v("\n    Fully Pay "),_c('strong',[_vm._v(_vm._s(_vm.items.length))]),_vm._v(" item"+_vm._s(_vm.items.length > 1 ? 's' : '')+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }